import Input from "../../../../Core/Fields/Floating/Input";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Date from "../../../../Core/Fields/Floating/Date";
import { useGetCountryListQuery, useGetCurrencyListQuery, useGetHolidayListQuery, useGetLetterHeadListQuery, useGetParentCompanyListQuery } from "../../../../store/api/companyapi";
import { MdTextDecrease } from "react-icons/md";
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const GeneralDetails = ({ pageState, handleChange, errors, onInputChange }) => {
  const { data: currency, isLoading: currencyLoader } = useGetCurrencyListQuery();
  const { data: country, isLoading: countryLoader } = useGetCountryListQuery();
  const { data: letterhead, isLoading: letterheadLoader } = useGetLetterHeadListQuery();
  const { data: holiday, isLoading: holidayLoader } = useGetHolidayListQuery();
  const { data: parentCompany, isLoading: parentCompanyLoader } = useGetParentCompanyListQuery({ "doctype": "Company", "fields": `["name"]`, "filters": `[["Company","is_group","=",1]]`, "view": "List" });  // ,"order_by":`tabCompany.parent_company+asc`
  let formattedCompanyData = [];
  if (Array.isArray(parentCompany?.message?.values) && Array.isArray(parentCompany?.message?.keys)) {
    formattedCompanyData = [...parentCompany.message.values].reverse().map(valueArr => {
      return parentCompany.message.keys.reduce((acc, key, index) => {
        acc[key] = valueArr[index];
        return acc;
      }, {});
    });
  };



  const gstRates = [
    { name: "0.0" },
    { name: "0.25" },
    { name: "1.0" },
    { name: "3.0" },
    { name: "1.5" },
    { name: "5.0" },
    { name: "6.0" },
    { name: "7.5" },
    { name: "0.1" },
    { name: "12.0" },
    { name: "18.0" },
    { name: "28.0" }
  ];
  const gstCategories = [
    { name: "Registered Regular" },
    { name: "Registered Composition" },
    { name: "Unregistered" },
    { name: "SEZ" },
    { name: "Overseas" },
    { name: "Deemed Export" },
    { name: "UIN Holders" },
    { name: "Tax Deductor" },
    { name: "Tax Collector" },
    { name: "Input Service Distributor" }
  ];
  return (
    countryLoader || currencyLoader || holidayLoader || letterheadLoader ? "" :
      <div>
        <div className="px-2 py-3" style={{ background: 'white' }}>
          <div style={{ display: 'flex' }} >
            <div className="col-md-6 px-2">
              <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div style={{ flex: 1 }}>
                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div style={{ flex: 1 }}>

                    <Input
                      id="companyName"
                      label="Company Name"
                      style={{ height: "30px", border: errors.companyName ? "1px solid red" : "" }}
                      value={pageState.companyName}
                      onChange={(e) => handleChange('companyName', e.target.value)}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="abbreviation"
                      label="Abbreviation"
                      style={{ height: "30px", border: errors.abbreviation ? "1px solid red" : "" }}
                      value={pageState.abbreviation}
                      onChange={(e) => handleChange('abbreviation', e.target.value)}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={currency.data}
                      label="Default Currency"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.defaultCurrency}
                      onChange={(val) => handleChange('defaultCurrency', val)}
                    />

                  </div>

                </div>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={country.data}
                      label="Country"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.country}
                      onChange={(val) => handleChange('country', val)}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={holiday.data}
                      label="Default Holiday List"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.defaultHolidayList}
                      onChange={(val) => handleChange('defaultHolidayList', val)}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={letterhead.data}
                      label="Default Letter Head"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.defaultLetterHead}
                      onChange={(val) => handleChange('defaultLetterHead', val)}
                    />
                  </div>



                </div>
                <div style={{ display: 'flex', gap: '15px' }}>


                  <div style={{ flex: 1 }}>
                    <Input
                      id="domain"
                      label="Domain"
                      style={{ height: "30px" }}
                      value={pageState.domain}
                      onChange={(e) => handleChange('domain', e.target.value)}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <Input
                      id="taxID"
                      label="Tax ID"
                      style={{ height: "30px" }}
                      value={pageState.taxID}
                      onChange={(e) => handleChange('taxID', e.target.value)}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <Date
                      id="dateOfEstablishment"
                      label="Date of Establishment"
                      value={pageState.dateOfEstablishment}
                      onChange={(val) => handleChange('dateOfEstablishment', val.target.value)}
                    />
                  </div>


                </div>
                <div style={{ display: 'flex', gap: '15px' }}>

                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={gstRates}
                      label="Default GST Rate"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.defaultGSTRate}
                      onChange={(val) => handleChange('defaultGSTRate', val)}
                    />
                    <p
                      style={{
                        fontSize: "9px",
                        color: "#2C2B31",
                        marginLeft: "4px",
                      }}
                    >
                      Sales / Purchase Taxes and Charges Template will be created based on this GST Rate
                    </p>
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={formattedCompanyData}
                      label="Parent Company"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.parentCompany}
                      onChange={(val) => handleChange('parentCompany', val)}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ height: '19px' }}></label>
                  <Checkbox
  id="IsGroup"
  label="Is Group"
  value={pageState.isgroup || false}   // ✅ use value instead of checked
  onChange={(checked) => onInputChange("isgroup", checked)}
/>



                  </div>

                </div>
              </div>
            </div>

            <div className="col-md-6 px-2">
              <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div style={{ flex: 1 }}>
                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Tax Details</p>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div style={{ flex: 1 }}>

                    <Input
                      id="gstinUin"
                      label="GSTIN/UIN"
                      style={{ height: "30px", border: errors.gstinUin ? "1px solid red" : "" }}
                      value={pageState.gstinUin}
                      onChange={(e) => handleChange('gstinUin', e.target.value)}
                    />
                  </div>
                  <div style={{ flex: 1 }}>

                    <Input
                      id="pan"
                      label="PAN"
                      style={{ height: "30px", border: errors.pan ? "1px solid red" : "" }}
                      value={pageState.pan}
                      onChange={(e) => handleChange('pan', e.target.value)}
                    />
                  </div>
                  <div style={{ flex: 1 }}>

                    <SelectSearch
                      list={gstCategories}
                      label="GST Category"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.gstCategory}
                      onChange={(val) => handleChange('gstCategory', val)}
                    />
                  </div>
                </div>
                <br />
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div style={{ flex: 1, height: '24px' }}>
                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Registration Details</p>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div style={{ flex: 1 }}>

                    <Textarea
                      id="registrationDetails"
                      label="Registration Details"
                      value={pageState.registrationDetails}
                      onChange={(e) => handleChange('registrationDetails', e.target.value)}
                      style={{ border: errors.registrationDetails ? "1px solid red" : "" }}
                    />
                    <p className="m-0" style={{ fontSize: '10px', paddingLeft: '3px' }} >Company registration numbers for your reference. Tax numbers etc.</p>

                  </div>


                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
  );
};

export default GeneralDetails;
